import React from 'react';

const renderVal = (val) => (val === 0 || val === '0' || !val ? '' : val);

const MICPreviewContent = ({
  micData,
  customer = null,
  warehouses = [],
  printRef,
  className = 'print-area',
  style = pdfContainerStyle,
}) => {
  if (!micData) return null;

  const totals = (micData.components || []).reduce((acc, c) => {
    acc.newQty += parseInt(c.newQty, 10) || 0;
    acc.rentalQty += parseInt(c.rentalQty, 10) || 0;
    acc.repairableQty += parseInt(c.repairableQty, 10) || 0;
    acc.nonRepairableQty += parseInt(c.nonRepairableQty, 10) || 0;
    const rowTotal =
      (parseInt(c.newQty, 10) || 0) +
      (parseInt(c.rentalQty, 10) || 0) +
      (parseInt(c.repairableQty, 10) || 0) +
      (parseInt(c.nonRepairableQty, 10) || 0);
    acc.weight += rowTotal * (parseFloat(c.weight) || 0);
    return acc;
  }, { newQty: 0, rentalQty: 0, repairableQty: 0, nonRepairableQty: 0, weight: 0 });

  const getShippingAddress = () => {
    if (!customer) return micData.shippingAddress || 'N/A';
    const shipAddr = customer.addresses?.find((a) => a.address_type === 'Shipping');
    if (!shipAddr) return micData.shippingAddress || 'N/A';
    return `${shipAddr.address || ''}, ${shipAddr.city || ''}, ${shipAddr.state || ''} - ${shipAddr.pincode || ''}`;
  };

  const getDestinationWarehouseAddress = () => {
    if (!micData.warehouse) return 'N/A';
    const warehouse = warehouses.find((w) => w.name === micData.warehouse);
    if (!warehouse) return micData.warehouse;
    return `${warehouse.address || ''}, ${warehouse.city || ''}, ${warehouse.state || ''} - ${warehouse.pincode || ''}`;
  };

  return (
    <div ref={printRef} style={style} className={className}>
      <table style={headerTableStyle}>
        <tbody>
          <tr>
            <td colSpan="4" style={{ ...headerTableCellStyle, textAlign: 'center', backgroundColor: '#f1f5f9', fontWeight: '800', fontSize: '18px' }}>
              MATERIAL INWARD CHECKLIST (MIC)
            </td>
          </tr>
          <tr>
            <td style={labelCellStyle}>MIC Date</td>
            <td style={valueCellStyle}>{micData.micDate}</td>
            <td style={labelCellStyle}>MIC Number</td>
            <td style={valueCellStyle}>{micData.micNo}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Type of MIC</td>
            <td style={valueCellStyle}>{micData.typeOfMIC}</td>
            <td style={labelCellStyle}>{micData.typeOfMIC === 'Interbranch Transfer' ? 'Document No.' : 'Pickup Challan (PC) No.'}</td>
            <td style={valueCellStyle}>{micData.pickupChallanNo || micData.referenceNo || 'N/A'}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Consignee</td>
            <td colSpan="3" style={{ ...valueCellStyle, fontWeight: 'bold' }}>
              {micData.typeOfMIC === 'Interbranch Transfer' ? micData.warehouse : micData.customerName}
            </td>
          </tr>
          <tr>
            <td style={labelCellStyle}>{micData.typeOfMIC === 'Interbranch Transfer' ? 'Destination Address' : 'Pickup From'}</td>
            <td colSpan="3" style={{ ...valueCellStyle, height: '60px', verticalAlign: 'top', whiteSpace: 'pre-wrap' }}>
              {micData.typeOfMIC === 'Interbranch Transfer' ? getDestinationWarehouseAddress() : getShippingAddress()}
            </td>
          </tr>
        </tbody>
      </table>

      <table style={pdfTableStyle}>
        <thead>
          <tr style={{ backgroundColor: '#f8fafc' }}>
            <th style={pdfThStyle}>S.No</th>
            <th style={pdfThStyle}>SKU</th>
            <th style={{ ...pdfThStyle, textAlign: 'left' }}>Description</th>
            <th style={pdfThStyle}>New</th>
            <th style={pdfThStyle}>Rental</th>
            <th style={pdfThStyle}>Repairable</th>
            <th style={pdfThStyle}>Non-Repairable</th>
            <th style={pdfThStyle}>Total Weight</th>
          </tr>
        </thead>
        <tbody>
          {micData.components?.map((component, index) => {
            const rowQty =
              (parseInt(component.newQty, 10) || 0) +
              (parseInt(component.rentalQty, 10) || 0) +
              (parseInt(component.repairableQty, 10) || 0) +
              (parseInt(component.nonRepairableQty, 10) || 0);
            const rowWeight = (rowQty * (parseFloat(component.weight) || 0)).toFixed(2);

            return (
              <tr key={component.id || index}>
                <td style={pdfTdStyle}>{index + 1}</td>
                <td style={pdfTdStyle}>{component.sku}</td>
                <td style={{ ...pdfTdStyle, textAlign: 'left' }}>{component.name || component.description}</td>
                <td style={pdfTdStyle}>{renderVal(component.newQty)}</td>
                <td style={pdfTdStyle}>{renderVal(component.rentalQty)}</td>
                <td style={pdfTdStyle}>{renderVal(component.repairableQty)}</td>
                <td style={pdfTdStyle}>{renderVal(component.nonRepairableQty)}</td>
                <td style={pdfTdStyle}>{renderVal(rowWeight)}</td>
              </tr>
            );
          })}
          <tr style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
            <td colSpan="3" style={{ ...pdfTdStyle, textAlign: 'right' }}>TOTAL SUMMARY</td>
            <td style={pdfTdStyle}>{renderVal(totals.newQty)}</td>
            <td style={pdfTdStyle}>{renderVal(totals.rentalQty)}</td>
            <td style={pdfTdStyle}>{renderVal(totals.repairableQty)}</td>
            <td style={pdfTdStyle}>{renderVal(totals.nonRepairableQty)}</td>
            <td style={pdfTdStyle}>{renderVal(totals.weight.toFixed(2))}</td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, marginTop: '20px', borderTop: '2px solid #000' }}>
        <tbody>
          <tr>
            <td style={{ ...labelCellStyle, width: '25%' }}>Prepared By:</td>
            <td style={{ ...valueCellStyle, width: '25%' }}>{micData.preparedBy}</td>
            <td rowSpan="3" style={{ ...valueCellStyle, width: '50%', fontSize: '11px', verticalAlign: 'top', lineHeight: '1.4', borderBottom: 'none' }}>
              I hereby confirm that the material has been physically verified as per the Invoice and Challan.
              The received quantity matches the documents, and the quality has been checked and found satisfactory.
            </td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Quantity Verified By:</td>
            <td style={valueCellStyle}>{micData.quantityVerifiedBy}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Vehicle Number:</td>
            <td style={valueCellStyle}>{micData.vehicleNumber}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Vehicle in Time:</td>
            <td style={valueCellStyle}>{micData.vehicleInTime}</td>
            <td style={{ ...valueCellStyle, borderLeft: '1px solid #000', borderTop: 'none' }}>Verified By: {micData.verifiedByFinance}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Vehicle out Time:</td>
            <td style={valueCellStyle}>{micData.vehicleOutTime}</td>
            <td style={{ ...valueCellStyle, borderLeft: '1px solid #000' }}>Date: {micData.declarationDate}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Date & Time:</td>
            <td style={valueCellStyle}>{micData.vehicleDateTime?.replace('T', ' ')}</td>
            <td style={{ ...valueCellStyle, borderLeft: '1px solid #000' }}>Signature: </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const pdfContainerStyle = { backgroundColor: 'white', padding: '40px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', width: '100%', boxSizing: 'border-box', color: '#000' };
const headerTableStyle = { width: '100%', borderCollapse: 'collapse', marginBottom: '15px', border: '1px solid #000' };
const headerTableCellStyle = { border: '1px solid #000', padding: '8px', fontSize: '13px' };
const labelCellStyle = { ...headerTableCellStyle, fontWeight: 'bold', backgroundColor: '#f2f2f2', width: '20%' };
const valueCellStyle = { ...headerTableCellStyle, backgroundColor: '#fff' };
const pdfTableStyle = { width: '100%', borderCollapse: 'collapse', marginTop: '15px', border: '1px solid #000' };
const pdfThStyle = { border: '1px solid #000', padding: '6px', fontSize: '12px', textAlign: 'center', fontWeight: 'bold' };
const pdfTdStyle = { border: '1px solid #000', padding: '6px', fontSize: '12px', textAlign: 'center' };

export default MICPreviewContent;
